import { type TokenGroup } from "../../types";
import { altitude } from "../globals/altitude";
import { amber } from "../globals/amber";
import { black } from "../globals/black";
import { cyan } from "../globals/cyan";
import { effects } from "../globals/effects";
import { flash } from "../globals/flash";
import { grass } from "../globals/grass";
import { gray } from "../globals/gray";
import { white } from "../globals/white";

export const background = {
  name: "background",
  variables: {
    accent: {
      type: "color",
      value: {
        dark: altitude.variables["9"].value.dark,
        light: altitude.variables["9"].value.light,
      },
    },
    "accent-subtle": {
      type: "color",
      value: {
        dark: altitude.variables["3"].value.dark,
        light: altitude.variables["3"].value.light,
      },
    },
    base: {
      type: "color",
      value: {
        dark: gray.variables["1"].value.dark,
        light: gray.variables["1"].value.light,
      },
    },
    black: {
      type: "color",
      value: {
        dark: black.variables.default.value.dark,
        light: black.variables.default.value.light,
      },
    },
    error: {
      type: "color",
      value: {
        dark: flash.variables["9"].value.dark,
        light: flash.variables["9"].value.light,
      },
    },
    "error-subtle": {
      type: "color",
      value: {
        dark: flash.variables["3"].value.dark,
        light: flash.variables["3"].value.light,
      },
    },
    "hover-accent": {
      type: "color",
      value: {
        dark: altitude.variables["10"].value.dark,
        light: altitude.variables["10"].value.light,
      },
    },
    "hover-subtle": {
      type: "color",
      value: {
        dark: gray.variables["4"].value.dark,
        light: gray.variables["4"].value.light,
      },
    },
    input: {
      type: "color",
      value: {
        dark: gray.variables["5"].value.dark,
        light: gray.variables["5"].value.light,
      },
    },
    overlay: {
      type: "color",
      value: {
        dark: effects.variables["scrim-(60)"].value.dark,
        light: effects.variables["scrim-(60)"].value.light,
      },
    },
    promotional: {
      type: "color",
      value: {
        dark: cyan.variables["9"].value.dark,
        light: cyan.variables["9"].value.light,
      },
    },
    "promotional-subtle": {
      type: "color",
      value: {
        dark: cyan.variables["3"].value.dark,
        light: cyan.variables["3"].value.light,
      },
    },
    selected: {
      type: "color",
      value: {
        dark: altitude.variables["3"].value.dark,
        light: altitude.variables["3"].value.light,
      },
    },
    subtle: {
      type: "color",
      value: {
        dark: gray.variables["3"].value.dark,
        light: gray.variables["3"].value.light,
      },
    },
    success: {
      type: "color",
      value: {
        dark: grass.variables["3"].value.dark,
        light: grass.variables["3"].value.light,
      },
    },
    surface: {
      type: "color",
      value: {
        dark: gray.variables["2"].value.dark,
        light: gray.variables["2"].value.light,
      },
    },
    warning: {
      type: "color",
      value: {
        dark: amber.variables["3"].value.dark,
        light: amber.variables["3"].value.light,
      },
    },
    white: {
      type: "color",
      value: {
        dark: white.variables.default.value.dark,
        light: white.variables.default.value.light,
      },
    },
  },
} as const satisfies TokenGroup<"background">;
